/* */ 
module.exports = System._nodeRequire ? System._nodeRequire('url') : require('url');